// submitProactivePlumberLead.ts
// ProactivePlumber.com - standard submit logic
// Version: v09
// Date: 2025-12-23 (America/Denver)

import { MASTER_CONFIG_OPTIONS } from "../00MasterConfig/MasterSystemConfig";
import type { WireLeadPayload } from "./plumberPayload";

const API_URL = MASTER_CONFIG_OPTIONS.API_URL;

export async function postProactivePlumberLead(payload: WireLeadPayload) {
  const url = `${API_URL}/leads/proactive-plumber`;

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `Request failed: ${res.status}`);
  }

  return res.json().catch(() => ({}));
}
